import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

export interface AttachmentAPIResponse {
  id: number;
  name: string;
  attachable_type: string;
  attachable_id: string;
  mime_type: string;
  artifact: string;
  size: number;
  created_by_id: number;
  created_at: string;
  updated_at: string;

}
@Injectable({ providedIn: 'root' })
export class AttachmentsAPISerivce {

  attachmentEndpoint = '/api/attachments';

  get endpoint() {
    return `${environment.apiBase}${this.attachmentEndpoint}`;
  }
  /**
   *
   */
  constructor(private _http: HttpClient) {
  }

  /**
   * Upload a file and attach it to an object.
   *
   * @param file File to upload
   * @param attachableId id of object to attach file to
   * @param attachableType type of object to attach file type default: TaggableLogbook
   *
   * Returns Observable with the following data:
   * ```
   * {
   *   "id": 40,
   *   "artifact": "original",
   *   "attachable_id": 1,
   *   "attachable_type": "TaggableLogbook",
   *   "created_by_id": 1,
   *   "mime_type": "image/png",
   *   "name": "sample.png",
   *   "size": 202259,
   *   "created_at": "2022-10-19 15:07:40 UTC",
   *   "updated_at": "2022-10-19 15:07:40 UTC"
   * }
   * ```
   */
  attachFile(file: any, attachableId: string, attachableType: string = 'TaggableLogbook') {
    const formData = new FormData();
    formData.append('attachable_id', attachableId);
    formData.append('attachable_type', attachableType);
    formData.append('file', file);
    return this._http.post<AttachmentAPIResponse>(this.endpoint, formData);
  }
}
